import { memo } from 'react';

import HBIcon from '../HBIcon/HBIcon';

function HBDropdownIconChevron(): JSX.Element {
    return <HBIcon name="nx-arrow-down-16" size="small" />;
}

export default memo(HBDropdownIconChevron);
